import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {fetchAgenciesList} from '../../picking/actions/scanning';
import apiActionCreator from '../../common/service/api/actionCreator';

export const isMarkedAllItems = (isChecked) => ({
  'type': ActionTypes.SELECT_ALL_ITEMS,
  'payload': isChecked,
});

export const changeSequencesMarked = (sequences) => ({
  'type': ActionTypes.CHANGE_SEQUENCES_MARKED,
  'payload': sequences,
});

export const clearLubricantsInfo = () => ({
  'type': ActionTypes.CLEAR_LUBRICANTS_INFO,
});

export const createLubricantsInvoice = (agency, data) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint':
        `/pickingVerifications/dealers/${agency.dealerIdentification}/` +
        `agencies/${agency.code}/sequences/invoice`,
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_LUBRICANTS_INVOICE,
        [
          () => {
            dispatch(clearLubricantsInfo());
            dispatch(fetchAgenciesList({'warehouse': data.warehouse}));
            return {
              'type': ActionTypes.CREATED_LUBRICANTS_INVOICE,
            };
          },
          (response) => {
            return MessageActions.addMessageBoxInfo(response.data.message);
          },
        ],
        [
          ActionTypes.CREATED_LUBRICANTS_INVOICE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
